var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "url(#paint0_linear_3708_2432)",
    stroke: "url(#paint1_linear_3708_2432)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_3708_2432)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6.15385,
    fill: "#E4E4E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5359 7.88128C11.7192 7.48391 12.284 7.48391 12.4673 7.88128L13.3282 9.74782C13.4029 9.90978 13.5564 10.0213 13.7335 10.0423L15.7748 10.2843C16.2093 10.3358 16.3838 10.873 16.0626 11.1701L14.5534 12.5657C14.4225 12.6868 14.3639 12.8672 14.3986 13.0421L14.7992 15.0582C14.8845 15.4875 14.4276 15.8194 14.0457 15.6057L12.2521 14.6017C12.0965 14.5145 11.9068 14.5145 11.7511 14.6017L9.95747 15.6057C9.57562 15.8194 9.11872 15.4875 9.204 15.0582L9.6046 13.0421C9.63936 12.8672 9.58074 12.6868 9.4498 12.5657L7.94065 11.1701C7.61937 10.873 7.79389 10.3358 8.22846 10.2843L10.2697 10.0423C10.4468 10.0213 10.6003 9.90978 10.675 9.74782L11.5359 7.88128Z",
    fill: "url(#paint2_linear_3708_2432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_3708_2432",
    x: 5.84619,
    y: 5.84619,
    width: 12.3076,
    height: 12.3077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.604167 0 0 0 0 0.604167 0 0 0 0 0.604167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3708_2432"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945833 0 0 0 0 0.945833 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3708_2432",
    result: "effect2_innerShadow_3708_2432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_2432",
    x1: 6.65228,
    y1: 3.36691,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5BCC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_2432",
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEAFB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3708_2432",
    x1: 4.82166,
    y1: 4.82033,
    x2: 15.7297,
    y2: 16.1518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankTwo);
export default __webpack_public_path__ + "static/media/RankTwo.45be5b47b13226a9dfc7a6b21f02995a.svg";
export { ForwardRef as ReactComponent };